import { urls } from '../constants'

export const getPlace = ({ coords }) =>
  new Promise(resolve =>
    fetch(urls.GET_PLACE(coords))
    .then(data => resolve(data.json())))
